import { type EnterpriseFormFields } from '@/components/ContentManager/NewSpacePage/types'

export const FORM_FIELDS: EnterpriseFormFields = {
  firstname: '',
  lastname: '',
  email: '',
  phone: '',
  country: {
    label: '',
    isoCode: '',
    calling_code: '',
  },
  company_name: '',
  company_size: null,
  job_title: '',
  industry: null,
  message: '',
}

// These are the names of the blocks defined in storyblok
// do not change unless you change them in there as well

export const PLAN_PRICES_COMPONENTS = {
  usd: 'usd_plan_price',
  eur: 'eur_plan_price',
}

// These are the tab names defined in storyblok.
// do not change unless you change it there as well.
export const TAB_NAMES = {
  selectPlan: 'SelectPlan',
  experienceDemo: 'ExperienceDemo',
  storyblokEnterprise: 'StoryblokEnterprise',
}

// These are the _uids used to identify the tabs in storyblok.
// do not change, unless they have been updated.
export const TABS_UIDS = {
  selectPlan: 'bac7ba6d-9c03-4669-aa63-6152d6890430',
  experienceDemo: 'b2723c36-8021-4d8d-98d9-4bb4cc64f548',
  storyblokEnterprise: '79c4402c-172a-4497-9996-1be08d1a2c25',
}
